<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="sidebar-brand-content c-sidebar-brand-full">
        <div class="brand-logo">
          <img src="/img/app_icon.png" alt="Save Animals" class="brand-logo-img" />
        </div>
        <div class="brand-text">
          <span class="brand-name">SAVE ANIMALS</span>
          <span class="brand-tagline">Together for their tomorrow</span>
        </div>
      </div>
      <div class="c-sidebar-brand-minimized">
        <img src="/img/app_icon.png" alt="SA" style="width: 28px; height: 28px; border-radius: 50%;" />
      </div>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>
